import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { notification, Switch } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import {
  TabContent,
  TabPane,
  Nav,
  NavLink,
  NavItem,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import Swal from "sweetalert2"; // Correct import for SweetAlert2
import { tokensApi } from "../../api/tokens/tokensApi";
import { FaCheckCircle } from "react-icons/fa";

const Tokens = () => {
  const [activeTab, setActiveTab] = useState(1);

  const [tokens, setTokens] = useState([]);
  const [isLoadingTokens, setIsLoadingTokens] = useState(true);
  const [tokenId, setTokenId] = useState("");
  const [tokenDetail, setTokenDetail] = useState({
    isActive: true,
    description: "",
    value: 0,
  });
  const [isLoadingTokenDetail, setIsLoadingTokenDetail] = useState(false);
  const handleSetTokenDetail = (e) => setTokenDetail({ ...tokenDetail, ...e });
  const getListToken = () => {
    tokensApi
      .getList()
      .then((res) => {
        setIsLoadingTokens(false);
        setTokens(res.data);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    getListToken();
  }, [activeTab]);

  useEffect(() => {
    if (tokenId) {
      setIsLoadingTokenDetail(true);
      tokensApi
        .getDetail(tokenId)
        .then((res) => {
          setIsLoadingTokenDetail(false);
          setTokenDetail(res.data);
        })
        .catch((err) => console.error(err));
    }
  }, [tokenId]);

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsLoadingTokenDetail(true);
    if (tokenId) {
      tokensApi
        .update({
          ...tokenDetail,
          id: tokenId,
        })
        .then((res) => {
          setIsLoadingTokenDetail(false);
          notification.success({message: "Update successfully"})
          setActiveTab(1);
        })
        .catch((err) => console.error(err));
    } else {
      tokensApi
        .create(tokenDetail)
        .then((res) => {
          setIsLoadingTokenDetail(false);
          notification.success({message: "Create successfully"})
          setActiveTab(1);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this imaginary file!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        tokensApi.delete(id).then(() => {
          getListToken();
        });
      }
    });
  };

  return (
    <>
      <div className="section-body">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <div className="header-action">
              <h1 className="page-title">Tokens</h1>
              <ol className="breadcrumb page-breadcrumb">
                <li className="breadcrumb-item">
                  <a href="">Aspirely</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Tokens
                </li>
              </ol>
            </div>
            <Nav tabs className="page-header-tab">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 1 })}
                  onClick={() => setActiveTab(1)}
                >
                  List
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 3 })}
                  onClick={() => {
                    setActiveTab(3);
                    setTokenDetail({
                      isActive: true,
                      description: "",
                      value: 0,
                    });
                    setTokenId("");
                  }}
                >
                  Detail
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
      </div>
      <div className="section-body mt-4">
        <div className="container-fluid">
          <TabContent activeTab={activeTab}>
            <TabPane tabId={1} className={classnames(["fade show"])}>
              <div className="table-responsive">
                <div className="table-responsive card">
                  {isLoadingTokens ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        minHeight: "100px",
                      }}
                    >
                      <Spinner size={"sm"} children="" />
                    </div>
                  ) : (
                    <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Description</th>
                          <th>Value</th>
                          <th>Active</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tokens.map((item, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.description}</td>
                              <td>{item.value}</td>
                              <td>{item.isActive ? <FaCheckCircle /> : ""}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                  onClick={() => {
                                    setTokenId(item.id);
                                    setActiveTab(3);
                                  }}
                                >
                                  <i className="fa fa-edit"></i>
                                </button>
                                <button
                                  onClick={() => handleDelete(item.id)}
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Delete"
                                >
                                  <i className="fa fa-trash-o text-danger"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </TabPane>
            <TabPane tabId={3} className={classnames(["fade show"])}>
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Token Detail</h3>
                  <div className="card-options">
                    <a
                      href="#"
                      className="card-options-collapse"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fe fe-chevron-up"></i>
                    </a>
                    <a
                      href="#"
                      className="card-options-remove"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fe fe-x"></i>
                    </a>
                  </div>
                </div>
                <form className="card-body">
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Description
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        value={tokenDetail.description}
                        onChange={(e) =>
                          handleSetTokenDetail({ description: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">Value</label>
                    <div className="col-md-7">
                      <input
                        type="number"
                        className="form-control"
                        value={tokenDetail.value}
                        onChange={(e) =>
                          handleSetTokenDetail({ value: Number(e.target.value) })
                        }
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Is Active ?
                    </label>
                    <div className="col-md-7">
                      <Switch
                        value={tokenDetail.isActive}
                        onChange={(e) => {
                          handleSetTokenDetail({ isActive: e });
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label"></label>
                    <div className="col-md-7">
                      <button
                        type="submit"
                        className="mr-1 btn btn-primary"
                        onClick={(e) => handleSubmit(e)}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </>
  );
};

export default Tokens;
